import { cAPI } from '../../../utils/cAPI';
import { getData, addEditData } from '../generic';

export const getProductDescriptionImportSettings = () => dispatch => getData(dispatch, cAPI.APGetProductDescriptionImportSettings, null, 'productDescriptionImport');

export const updateProductDescriptionImportSettings = (formData, preventRefetch = false) => dispatch => addEditData(dispatch, cAPI.APUpdateProductDescriptionImportSettings, formData, preventRefetch ? null : 'productDescriptionImport');

export const importProductDescription = formData => dispatch => addEditData(dispatch, cAPI.APImportProductDescription, formData, 'productDescriptionImport', false, false, false, false, true);

